<div class="chat-section" [class.zk-hidden]="!isChatOpen()">
	<div id="header-row">
		<div id="feed-header">
			<div class="title full-width">
				{{ listTitle }}
			</div>
			<ng-template *ngTemplateOutlet="closeButton"></ng-template>
			<ng-template *ngTemplateOutlet="vcButtons"></ng-template>
		</div>

		<div id="chatbox-header" class="zk-hidden">
			<zk-icon
				class="zk-m-auto zk-cursor-pointer zk-mr-4"
				[name]="'full-arrow-left'"
				[width]="'20px'"
				[height]="'20px'"
				id="back-btn"
			>
			</zk-icon>
			<span id="chat-title" class="full-width title">Chat Header</span>
			<ng-template *ngTemplateOutlet="closeButton"></ng-template>
			<ng-template *ngTemplateOutlet="vcButtons"></ng-template>
		</div>
	</div>
	<div id="chat-div-container" class="chat" [class.has-error]="chatHasError()">
		<span *ngIf="!chatHasError()">
			{{ 'CHAT.LOADING' | translate }}
		</span>
		<span *ngIf="chatHasError()">
			{{ 'CHAT.ERROR' | translate }}
		</span>
	</div>
</div>

<div
	[class.zk-hidden]="!getUnreadMessage()"
	(click)="goToUnreadMessage()"
	class="unread-popup zk-cursor-pointer"
>
	<img
		*ngIf="getUnreadMessage()?.lastMessage.sender.photoUrl; else noAvatarUser"
		[src]="getUnreadMessage()?.lastMessage.sender.photoUrl"
		[alt]="getUnreadMessage()?.lastMessage.sender.name"
	/>

	<ng-template #noAvatarUser>
		<img
			[src]="'/assets/images/nophoto_blue_solid.png'"
			[alt]="getUnreadMessage()?.lastMessage.sender.name"
		/>
	</ng-template>

	<div>
		<p class="user-name zk-m-0">
			{{ getUnreadMessage()?.lastMessage.sender.name }}
		</p>
		<p class="zk-m-0" *ngIf="getUnreadMessage()?.lastMessage.type == 'text'">
			{{ getUnreadMessage()?.lastMessage.body }}
		</p>

		<p class="zk-m-0" *ngIf="getUnreadMessage()?.lastMessage.type == 'media'">
			<zk-icon [name]="'attachment'"></zk-icon>
		</p>
	</div>
</div>

<ng-template #closeButton>
	<zk-icon
		class="close zk-cursor-pointer"
		[name]="'close'"
		(click)="closeChat()"
	></zk-icon>
</ng-template>

<ng-template #vcButtons>
	<div class="switch-controls" *ngIf="videoConference">
		<span
			class="freud-icon freud-icon-md freud-icon-edit"
			[pTooltip]="'SESSION.SIDEBAR.PROMPTUARY_AND_NOTES' | translate"
			tooltipPosition="left"
			(click)="chatService.callSwitch('sidebar')"
		></span>

		<span
			class="freud-icon freud-icon-md freud-icon-window-minimize"
			[pTooltip]="'SESSION.SIDEBAR.MINIMIZE' | translate"
			tooltipPosition="left"
			(click)="chatService.callSwitch('switch')"
		></span>
	</div>
</ng-template>
